import React, { useCallback } from "react"
import { get } from "lodash"
import { Box, Typography, useTheme } from "@mui/material"
import { useNavigate } from "react-router-dom"

import { useFeatureDetail } from "hooks/feature"
import { usePageSideBarLayout } from "providers/ui/hooks"
import { useTranslation } from "providers/i18n"
import { useGeoLocation } from "providers/geolocation"

import { PageCard, PageCardContent } from "components/card"
import {
  ReservationContactCard,
  ReservationQRCodeCard,
  useOccupantReservations,
} from "extensions/iconsiam/components/domains/reservation"
import { PlaceDetailSideBar } from "extensions/iconsiam/components/domains/features/PlaceDetailSideBar"

export const OccupantReservationKioskHPage = ({ Layout }) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const { t } = useTranslation()
  const { dataLoaded, ...data } = useFeatureDetail()
  const { deviceLocation } = useGeoLocation()

  const isReadyToNavigate = !!deviceLocation && get(data, "isNavigatable", true)

  const { pageCardSideBar } =
    theme.components[`PlaceDetailPage`]?.styleOverrides || {}

  const {
    pageCard,
    pageCardContent,
    pageCardHeaderText,
    reservationContainer,
    reservationCard,
  } = theme.components?.[`ReservationPage`]?.styleOverrides || {}

  const { reservationMethods, contactMethod } = useOccupantReservations(data)

  const onNavigate = useCallback(() => {
    if (!isReadyToNavigate) return
    navigate(`/maps/dir/unknown/${data?.id}`)
  }, [navigate, isReadyToNavigate, data?.id])

  usePageSideBarLayout({
    sidebar: {
      open: true,
    },
  })

  return (
    <Layout
      aside={
        <PageCard sx={pageCardSideBar}>
          <PlaceDetailSideBar
            data={data}
            onNavigate={onNavigate}
            showAdditionalButtons={false}
          />
        </PageCard>
      }
      children={
        <PageCard sx={pageCard}>
          <PageCardContent sx={pageCardContent}>
            <Typography variant="h3" component="h2" sx={pageCardHeaderText}>
              {t("Reservation choices")}
            </Typography>
            <Box sx={reservationContainer}>
              {reservationMethods.map((data, index) => (
                <ReservationQRCodeCard
                  data={data}
                  sx={reservationCard}
                  key={`reservation-${index}`}
                />
              ))}
              {contactMethod && (
                <ReservationContactCard
                  data={contactMethod}
                  sx={reservationCard}
                />
              )}
            </Box>
          </PageCardContent>
        </PageCard>
      }
    />
  )
}
